import htmlReactParser from './index.js';
export { default } from './index.js';

var domToReact = htmlReactParser.domToReact;
var Element = htmlReactParser.Element;

export { Element, domToReact };
